import { Icon, Skeleton, Spinner } from '@sendible/design-system/src';
import { Container, HeaderBar, HeaderLeft, HeaderRight, BackButton, ContentArea, Toolbar, ToolbarLeft, ToolbarRight } from '../../index.styles';

type LoadingSkeletonProps = {
  onBack: () => void;
};

export const LoadingSkeleton = ({ onBack }: LoadingSkeletonProps) => (
  <Container>
    <HeaderBar>
      <HeaderLeft>
        <BackButton
          type="button"
          onClick={onBack}
        >
          <Icon name="close" />
        </BackButton>
        <Skeleton
          width="16rem"
          height="1.5rem"
        />
      </HeaderLeft>
      <HeaderRight>
        <Skeleton
          width="5rem"
          height="2rem"
          shape="free"
        />
      </HeaderRight>
    </HeaderBar>
    <Toolbar>
      <ToolbarLeft>
        <Skeleton
          width="12rem"
          height="2rem"
        />
      </ToolbarLeft>
      <ToolbarRight>
        <Skeleton
          width="14rem"
          height="2rem"
        />
      </ToolbarRight>
    </Toolbar>
    <ContentArea style={{ alignItems: 'center', justifyContent: 'center' }}>
      <Spinner size="lg" />
    </ContentArea>
  </Container>
);
